import React from 'react'

export default function CodeSyntax({children}) {
	return (
		<span style={{color: "var(--shiki-token-function)"}}>
            {children}
		</span>
	)
}
